import { render, staticRenderFns } from "./EnableBlockedFeatures.vue?vue&type=template&id=4fbbd2ba&scoped=true&"
import script from "./EnableBlockedFeatures.vue?vue&type=script&lang=js&"
export * from "./EnableBlockedFeatures.vue?vue&type=script&lang=js&"
import style0 from "./EnableBlockedFeatures.vue?vue&type=style&index=0&id=4fbbd2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbd2ba",
  null
  
)

export default component.exports